// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7662":"9bf9a0db6b9bf140","7782":"e31206c125a70a06","8615":"687e28b7d653e58f"}[chunkId] + ".css";
};